import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      {/* loader 1 */}
      <div className="loader "></div>
    </div>
  );
};

export default Loader;
